"use client";

import React from "react";
import { Card, CardContent, Button } from "@west-tennessee-consulting/ui";
import { HardDrive, RefreshCw } from "lucide-react";
import { EmptyState } from "@west-tennessee-consulting/ui";

interface GoogleDriveErrorStateProps {
  className?: string;
  message?: string;
  onRetry: () => void;
}

export function GoogleDriveErrorState({
  className,
  message = "Failed to access Google Drive",
  onRetry,
}: GoogleDriveErrorStateProps) {
  return (
    <Card className={className}>
      <CardContent className="p-6">
        <EmptyState
          icon={HardDrive}
          title="Drive Access Error"
          description={message}
          action={
            <Button onClick={onRetry} variant="outline">
              <RefreshCw className="h-4 w-4 mr-2" />
              Retry
            </Button>
          }
        />
      </CardContent>
    </Card>
  );
}
